import { CoverLetter, Resume } from 'packages/types'
import { A4_FACTOR, US_LETTER_FACTOR } from 'builder/modules/constants'
import { isResumeDocument } from 'builder/utils/getDocumentType'
import { LETTER_FORMAT_TEMPLATES } from '../constants'

function templateHeightFactorSelector(currentDocument: Resume | CoverLetter) {
  if (
    isResumeDocument(currentDocument) &&
    currentDocument?.templateSettings?.[currentDocument?.template]
  ) {
    return currentDocument?.templateSettings?.[currentDocument?.template]?.format === 'US_LETTER'
      ? US_LETTER_FACTOR
      : A4_FACTOR
  }

  const isLetterFormat =
    currentDocument?.template && LETTER_FORMAT_TEMPLATES?.includes(currentDocument?.template)
  return isLetterFormat ? US_LETTER_FACTOR : A4_FACTOR
}

export default templateHeightFactorSelector
